import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { bestPriceRates } from '../../../constants/best-price.constants';
import { languages } from '../../../constants/language.constants';
import { cookieVariables } from '../../../constants/cookie-variables.constants';
import { CookieAppService } from '@shared/common/services/cookie-app/cookie-app.service';
import { isPlatformBrowser } from '@angular/common';
import { currencies } from '../../../constants/currencies.constants';

@Component({
  selector: 'app-best-price-tooltip',
  templateUrl: './best-price-tooltip.component.html',
  styleUrls: ['./best-price-tooltip.component.scss'],
  standalone: false
})
export class BestPriceTooltipComponent implements OnInit {
  bestPriceRates = bestPriceRates;
  math = Math;
  checkinDate: Date;
  checkoutDate: Date;
  isVisibleState: boolean;
  cookieVariables = cookieVariables;
  bestPriceTooltipComponent: HTMLElement;
  currencies = currencies;

  @Input() set isVisible(isVisible: boolean) {
    if (isVisible) {
      this.setElemPosition();
    }
    this.isVisibleState = isVisible;
  }
  @Input() parentScrollingElem: HTMLElement;
  @Input() pageType: string;
  @Input() isLastItem: boolean;
  @Input() position: string;
  @Input() currentLang: languages;
  @Input() amount: number;
  @Input() currency: string;
  @Input() bookingLengthInDays: number;
  @Input() suiteFilterLimitInDays: number;
  @Input() guests: number;
  @Input() bannerType: boolean;
  @Input() adults: number;
  @Input() children: number;
  @Input() set checkin(checkin: string) {
    if (checkin) {
      this.checkinDate = new Date(checkin);
    }
  }
  @Input() set checkout(checkout: Date | string) {
    if (checkout) {
      this.checkoutDate = new Date(checkout);
    }
  }

  @ViewChild('bestPrice') bestPriceElem: ElementRef;
  @Output() closeBanner: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public element: ElementRef,
    public cookieAppService: CookieAppService,
    @Inject(PLATFORM_ID) public platformId: any
  ) {}

  ngOnInit(): void {}

  setElemPosition() {
    if (isPlatformBrowser(this.platformId) && this.bestPriceElem && this.element) {
      this.isLastItem = !(
        (this.parentScrollingElem ? this.parentScrollingElem.offsetHeight : window.innerHeight) >
        this.element.nativeElement?.getBoundingClientRect()?.top + this.bestPriceElem.nativeElement.offsetHeight + 20
      );
    }
  }

  handleScrollToDatePicker() {
    let element = document.getElementById('bookingWidget');
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.closeBanner.emit();
  }

  @HostListener('document:click', ['$event'])
  clickOutsideBanner(event) {
    let element = document.getElementById('app-best-price');
    if (this.isVisibleState && !element.contains(event.target)) {
      this.closeBanner.emit();
    }
  }

  @HostListener('window:scroll')
  onScroll() {
    this.closeBanner.emit();
  }
}
